export const MAP_PREFIX = "1PuQa7K62MiKCtssSLKy1kh56WWU7MtUR5";
export const DEFAULT_SAT_PER_KB = 100;
export const API_HOST = "https://ordinals.gorillapool.io/api";